var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLabel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 45,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 30,
  x: 1,
  y: 13.835,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-weak)",
  strokeWidth: 2,
  rx: 7
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 4,
  x: 2,
  y: 0.835,
  fill: "var(--hop-neutral-surface-strong)",
  rx: 2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 108,
  height: 4,
  x: 13.853,
  y: 26.834,
  fill: "var(--hop-neutral-surface-weak)",
  rx: 2
})));
export default SvgLabel;